<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';

interface Props {
    transferInfo?: OperationInfo;
    transferBalance: number;
}

const props = withDefaults(defineProps<Props>(), {
    transferInfo: undefined,
    transferBalance: 0
});

const remainingToTransfer = computed(() => {
    if (!props.transferInfo?.amount) return 0;
    return props.transferInfo.amount - props.transferBalance;
});
</script>

<template>
    <div class="group p-4 my-4 bg-blue-50 rounded-lg shadow-md ring-1 ring-blue-200 transition-all duration-200">
        <div class="flex flex-col gap-3">
            <h3 class="text-lg font-semibold text-blue-900">
                Transfer Status:
            </h3>
            <div class="flex flex-col gap-2 text-blue-800">
                <p class="flex items-center gap-2">
                    Total transferred: <span class="font-medium">{{ transferBalance }} fish</span>
                </p>
                <p class="flex items-center gap-2">
                    Left to be transferred: <span class="font-medium">{{ remainingToTransfer }} fish</span>
                </p>
            </div>
        </div>
    </div>
</template>